module.exports = __webpack_public_path__ + "img/zizhi.8cd4b053.png";